import useRouter from 'use-react-router';
import hideSvg from 'common/assets/svg/common/hide.svg';
import SvgRender from 'common/components/general/SvgRender';

import { FC } from 'react';
import { useState, useEffect } from 'react';
import { parseQueryParams } from '@webthatmatters/orca-table';
import { TableTopFilterType } from '@/common/types/front-entities/table.ts';
import { FilterOperationType } from '@/library/types/table-query';

type HiddenButtonProps = {
  className?: string;
  label: string;
  setTopFilters: (filters: TableTopFilterType[]) => void;
  topFilters: TableTopFilterType[];
};

const HiddenButton: FC<HiddenButtonProps> = ({ className, label, topFilters, setTopFilters }) => {
  const { location } = useRouter();
  const [isHidden, setIsHidden] = useState(false);

  const onHide = () => {
    const hiddenFilter: TableTopFilterType = {
      name: 'hidden',
      operation: '=' as FilterOperationType,
      value: 'true'
    };
    const newFilters: TableTopFilterType[] = [hiddenFilter, ...topFilters];

    setTopFilters(newFilters);
  };

  const onGoBack = () => {
    const hiddenFilterExists = topFilters.find(f => f.name === 'hidden');
    const newFilters: TableTopFilterType[] = hiddenFilterExists
      ? topFilters.map(f => (f.name === 'hidden' ? { ...f, value: undefined } : f))
      : [...topFilters, { name: 'hidden', operation: '=' as FilterOperationType, value: 'false' }];
    setTopFilters(newFilters);
  };

  useEffect(() => {
    if (location.search) {
      const params = parseQueryParams(location.search);

      if (
        params.filters &&
        params.filters.length > 0 &&
        params.filters.find(el => el.name === 'hidden' && el.value === 'true')
      ) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }
    } else {
      setIsHidden(false);
    }
  }, [location.search]);

  return (
    <div className={`d-flex align-items-center ${className ? className : ''}`}>
      {isHidden ? (
        <div className="fs-10 d-flex align-items-center">
          <div
            onClick={onGoBack}
            className="d-inline-flex align-items-center cursor-pointer back-to-list"
            data-cy="back-to-list"
          >
            Back to List
          </div>
          <div className="text-primary">Hidden</div>
        </div>
      ) : (
        <div
          onClick={onHide}
          className="d-inline-flex align-items-center text-primary cursor-pointer "
          data-cy="see_hidden"
        >
          <SvgRender src={hideSvg} style={{ width: 14, height: 14 }} className="me-1" />
          <span className="lh-1 fs-10 fw-normal">See hidden {label}</span>
        </div>
      )}
    </div>
  );
};

export default HiddenButton;
